//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "UploadForm",
  components: {},
  props: ["fileDataTypes"],
  mounted: async function () {
    let response = await BackendServices.getRetailersForFileUpload();
    this.retailerList = response.data;

    if (!this.can('system_settings')) {
      let asuReq = await BackendServices.getAllowedStructureUploads();
      this.allowedStructureUploads = asuReq.data.allowed_uploads.map(row => row[0]);
    }

  },
  data: () => ({
    allowedStructureUploads: [],
    newUploadClicked: 0,
    validForm: false,
    retailer: null,
    filesToUpload: [],
    retailerLevelList: [],
    retailerList: [],
    insignia: null,
    insigniaList: [],
    showDate: false,
    type: null,
    typeList: [],
    date: null,
    fileModel: null,
    fileType: null,
    loadingMappings: false
  }),
  computed: {
    templateUrl: function () {
      return this.typeList.filter((i) => i.id === this.type).pop().template_url;
    },
  },
  methods: {
    required,
    noValidation,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    findInsigniasForRetailer: async function (retailerId) {
      let response = await BackendServices.getInsigniaByRetailerForFileUpload(
        retailerId
      );

      if (Array.isArray(response.data)) {
        this.insigniaList.splice(0, this.insigniaList.length, ...response.data);
        this.typeList = [];
      } else {
        this.insigniaList = [];
        response = await BackendServices.getFileUploadMappings({
          page: 1,
          rowsPerPage: 100,
        });
        this.typeList = response.data.filter(
          (item) => item.store_level_element_id === this.retailer
        );
      }
    },
    updateData() {
      this.$emit("changed-file-object", {
        file_upload_mapping_id: this.type,
        file: this.filesToUpload,
        reference_date: this.date,
      });
    },
    loadFileUploadMappings: async function () {
      if (
        this.fileModel ===
        this.fileDataTypes.filter((item) => item.name === "Estrutura").pop().id
      ) {
        this.loadingMappings = true;
        let response = await BackendServices.getFileUploadMappings({
          page: 1,
          rowsPerPage: 200,
        });
        this.typeList = response.data.filter(
          (i) => i.file_upload_data_type_id === this.fileModel
        );
        if (!this.can('system_settings')) {
          this.typeList = this.typeList.filter(e => this.allowedStructureUploads.includes(e.id));
        }
      }
      this.loadingMappings = false;
    },
    changeRetailerSelection: function (retailerId) {
      this.insignia = null;
      this.type = null;
      this.findInsigniasForRetailer(retailerId);
    },
    changeInsigniaSelection: async function (insigniaId) {
      //Responsavel por lixar dropdowns em FE TODO: fix
      let response = await BackendServices.getFileUploadMappings({
        page: 1,
        rowsPerPage: 150,
      });
      this.type = null;
      this.typeList = response.data.filter(
        (item) => item.store_level_element_id === insigniaId
      );
    },
    changeType: function () {
      this.showDate = !this.typeList
        .filter((item) => item.id === this.type)
        .pop().has_date;
      this.updateData();
    },
    changeDate: function () {
      this.updateData();
    },
    changeFileUpload() {
      this.updateData();
    }
  },
};
